// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelay__Validators__KeyFacts__Price = require("./PropertyWizardFormRelay__Validators__KeyFacts__Price.bs.js");
var PropertyWizardFormRelay__Validators__KeyFacts__Address = require("./PropertyWizardFormRelay__Validators__KeyFacts__Address.bs.js");
var PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.bs.js");
var PropertyWizardFormRelay__Validators__KeyFacts__PropertyType = require("./PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.bs.js");

var SubFields = {
  Address: undefined,
  Price: undefined,
  PropertyType: undefined
};

var convertFragment = PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function use$2(draft, formState) {
  var draft$1 = use(draft);
  var formState$1 = use$1(formState);
  var priceIsValid = PropertyWizardFormRelay__Validators__KeyFacts__Price.useIsValid(draft$1.fragmentRefs);
  var propertyTypeIsValid = PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.useIsValid(draft$1.fragmentRefs);
  var addressIsValid = PropertyWizardFormRelay__Validators__KeyFacts__Address.useIsValid(draft$1.fragmentRefs, formState$1.fragmentRefs);
  return PropertyWizardRelayUtils.FormUtils.allSubStepsValid([
              priceIsValid,
              propertyTypeIsValid,
              addressIsValid
            ]);
}

var FormUtils;

exports.FormUtils = FormUtils;
exports.SubFields = SubFields;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.use = use$2;
/* RescriptRelay_Fragment Not a pure module */
